import { api } from 'common/frontend/api';
import { ShopPublicInfo } from 'common/types';

export const clearImageReferences = async (
	url: string,
	shopPublicInfo: ShopPublicInfo | undefined,
) => {
	const productImagesToRemove = await api()
		.products.get.where('images', 'array-contains-any', [url])
		.get();
	productImagesToRemove.forEach(async ({ id, images }) => {
		await api()
			.products.doc(id)
			.update({
				images:
					images?.length === 1 ? api().FieldValues.delete() : api().FieldValues.arrayRemove(url),
			});
	});

	const productImageToDelete = await api().products.get.where('image', '==', url).get();
	productImageToDelete.forEach(async ({ id }) => {
		await api().products.doc(id).update({
			image: api().FieldValues.delete(),
		});
	});

	const categoryImagesToNullify = await api()
		.productCategories.get.where('imageUrl', '==', url)
		.get();
	categoryImagesToNullify.forEach(async ({ id }) => {
		await api().productCategories.doc(id).update({
			imageUrl: null,
		});
	});

	if (!!shopPublicInfo && shopPublicInfo?.logoImgUrl === url) {
		await api().shops.doc(shopPublicInfo.shopId).public.update({
			logoImgUrl: api().FieldValues.delete(),
		});
	}
};
